import { DateTime } from "luxon";
import { SectionItem } from "./SideBar/Section/Item";
import { Profile } from "@max/common/user";

export const limitDataByMonthRange = <T>(
  data: { data?: T[] },
  monthRange: [number, number],
  monthFn: (entry: T) => string,
) => {
  const currentDate = DateTime.now().startOf("month");
  const startDate = currentDate.plus({ months: monthRange[0] });
  const endDate = currentDate.plus({ months: monthRange[1] });
  return data?.data?.filter((monthEntry) => {
    const reportDate = DateTime.fromISO(monthFn(monthEntry));
    return reportDate >= startDate && reportDate <= endDate;
  }) as (typeof data)["data"];
};

export const hasAccessToRoute = (route: SectionItem, profile: Profile) =>
  route.groups?.includes("all") ||
  route.groups?.some(
    (group) => group !== "all" && profile.groups?.includes(group),
  );
